/**
 * useAppSelector Hook
 * Typed selector hook for store-front Redux state
 */

import { TypedUseSelectorHook, useSelector } from 'react-redux';

import type { SFRootState } from '../store';

// Use throughout the app instead of plain `useSelector`
export const useAppSelector: TypedUseSelectorHook<SFRootState> = useSelector;

export default useAppSelector;
